import React from 'react';
import { Shield, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const StatsPanel = () => {
  const navigate = useNavigate();
  
  // Energy widget removed per design update

  const badges = [
    { name: 'Guest Stream', progress: 0.83, icon: Shield },
    { name: 'Quest Stream', progress: 0.7, icon: Shield }
  ];

  return (
    <div className="panel stats-panel">
      <h2 className="panel-title">Progress Overview</h2>
      
      {/* Energy Bar removed */}

      {/* Badges Row */}
      <div className="badges-widget">
        <div className="shields-row">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="shield-circle">
              <Shield size={20} />
            </div>
          ))}
        </div>

        <div className="badges-bars">
          {badges.map((badge, index) => (
            <div key={index} className="badge-bar-item">
              <div className="badge-bar-label">
                <span className="label-name">{badge.name}</span>
              </div>
              <div className="badge-bar-track">
                <div className="badge-bar-fill" style={{ width: `${badge.progress * 100}%` }} />
              </div>
              <span className="badge-bar-pct">{Math.round(badge.progress * 100)}%</span>
            </div>
          ))}
        </div>

        <button className="view-link" onClick={() => navigate('/badges')}>
          view badges <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default StatsPanel;
